import c from "md5";
const i = (n) => n.reduce((t, e) => t + e, 0) / n.length, g = (n) => n.map((t) => t - 10), s = (n, t) => i(t) <= n ? t : s(n, g(t)), h = (n) => `00${n.toString(16)}`.slice(-2), p = (n) => n ? { max: 255, min: 150 } : { max: 190, min: 50 }, x = (n, t = !1) => {
  const e = p(t), a = c(n), m = Array.from({ length: 3 }).map((r, o) => a.slice(3 * o, 3 * o + 3)).map((r) => parseInt(r, 16)).map((r) => Math.max(e.min, Math.round(255 * (r / 4095))));
  return `#${s(e.max, m).map(h).join("")}`;
};
export {
  x as genColorFromText
};
//# sourceMappingURL=index.js.map
